import React from 'react'

/**
 * Custom RJSF field for arrays where undefined and [] have different meanings:
 * - undefined: field not set, parent array is left unchanged
 * - []: empty array, explicitly overrides with an empty list
 * - [...]: array with items, explicitly overrides with those items
 *
 * Usage in uiSchema: { "ui:field": "nullablearray" }
 */
export const NullableArrayField = ({ schema, uiSchema, formData, onChange, registry, idSchema, ...rest }) => {
  const isActive = Array.isArray(formData)

  if (!isActive) {
    return (
      <div className="form-group">
        <label className="control-label" htmlFor={idSchema?.$id}>{schema.title}</label>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '6px 10px',
            background: '#f7f7f7',
            border: '1px dashed #bbb',
            borderRadius: 4,
          }}
        >
          <em style={{ flex: 1, fontSize: '0.85em', color: '#999' }}>Liste non définie</em>
          <button
            type="button"
            className="btn btn-xs btn-default"
            onClick={e => {
              e.preventDefault()
              onChange([])
            }}
          >
            Définir
          </button>
        </div>
      </div>
    )
  }

  const { 'ui:field': _field, ...innerUiSchema } = uiSchema
  const ArrayField = registry.fields.ArrayField
  const count = formData.length

  return (
    <div className="form-group">
      <label className="control-label" htmlFor={idSchema?.$id}>{schema.title}</label>
      <div style={{ borderLeft: '3px solid #ccc', paddingLeft: 8, marginBottom: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
          <em style={{ fontSize: '0.85em', color: '#999' }}>
            {count === 0 ? 'Liste vide' : `${count} élément${count > 1 ? 's' : ''}`}
          </em>
          <button
            type="button"
            className="btn btn-xs btn-default"
            onClick={e => {
              e.preventDefault()
              onChange(undefined)
            }}
            title="Supprimer la liste — la valeur du module sera conservée"
          >
            <i className="glyphicon glyphicon-trash" /> Supprimer
          </button>
        </div>
        <ArrayField
          schema={{ ...schema, title: '' }}
          uiSchema={innerUiSchema}
          formData={formData}
          onChange={onChange}
          registry={registry}
          idSchema={idSchema}
          {...rest}
        />
      </div>
    </div>
  )
}
